<template>
  <b-modal
    v-model="isShowModal"
    size="md"
    :title="titleHeader"
    hide-footer
    :centered="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <BaseELabel
            :class="$style.status"
            class="text-left"
            :label="alertMessage"
          />
        </b-col>
      </b-row>
      <b-row class="mt-3 float-right">
        <b-col>
          <BaseEButton variant="cancel" @click="confirmCancelClicked">{{
            cancelVariant
          }}</BaseEButton>
          <BaseEButton @click="confirmOkClicked">
            {{ okVariant }}
          </BaseEButton>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  props: {
    alertMessage: {
      type: String,
      default: '',
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
    titleHeader: {
      type: String,
      default: '',
    },
    okVariant: {
      type: String,
      default: 'Ok',
    },
    cancelVariant: {
      type: String,
      default: 'Cancel',
    },
  },
  computed: {
    isShowModal() {
      return this.modalShow
    },
  },
  methods: {
    confirmOkClicked() {
      this.$emit('confirmOkClicked')
    },
    confirmCancelClicked() {
      this.$emit('confirmCancelClicked')
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';
.status {
  margin: 0.625rem 0;
  font-size: $size-content-font;
  font-weight: $label-font-weight;
  color: $color-text-gray;
}
.btnHover:hover,
.cancelBtn:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
}
.cancelBtn {
  font-weight: 600 !important;
  color: $color-button-bg !important;
  text-shadow: 0;
  background-color: $color-button-text !important;
  border: 1px solid $color-button-bg;
  box-shadow: 0;
}
</style>
